import { render, staticRenderFns } from "./base_input.vue?vue&type=template&id=b476ad48&scoped=true&"
import script from "./base_input.vue?vue&type=script&lang=ts&"
export * from "./base_input.vue?vue&type=script&lang=ts&"
import style0 from "./base_input.vue?vue&type=style&index=0&id=b476ad48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b476ad48",
  null
  
)

export default component.exports